.container {
    display: flex;
    justify-content: space-between;    
    flex-direction: column;
    height: 100%;
}

.count, .countHighlight {
    text-align: center;
    letter-spacing: 0.1px;
    color: var(--hps-white);
    text-transform: uppercase;
    font-size: 40px;
    font-family: var(--hps-primary-font);
    font-weight: bolder;
}

.countHighlight {
    color: var(--hps-yellow);

}

.container:hover {
    cursor: pointer;
}

.skeleton {
    margin: 0 auto;
}